<template>
  <article class="customer">
    <div class="customer-block">
      <div class="title">{{ title }}</div>
      <div class="list-block">
        <div class="list" v-for="(item, index) in list" :key="index">
          <img :src="item" alt="行业logo" />
        </div>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  data() {
    return {
      title: 'e签宝房地产行业客户',
      list: [
        require('@/assets/images/real-estate/customer-1.jpg'),
        require('@/assets/images/real-estate/customer-2.jpg'),
        require('@/assets/images/real-estate/customer-3.jpg'),
        require('@/assets/images/real-estate/customer-4.jpg'),
        require('@/assets/images/real-estate/customer-5.jpg'),
        require('@/assets/images/real-estate/customer-6.jpg'),
        require('@/assets/images/real-estate/customer-7.jpg'),
        require('@/assets/images/real-estate/customer-8.jpg'),
        require('@/assets/images/real-estate/customer-9.jpg'),
        require('@/assets/images/real-estate/customer-10.jpg'),
        require('@/assets/images/real-estate/customer-11.jpg'),
        require('@/assets/images/real-estate/customer-12.jpg'),
        require('@/assets/images/real-estate/customer-13.jpg'),
        require('@/assets/images/real-estate/customer-14.jpg'),
        require('@/assets/images/real-estate/customer-15.jpg'),
        require('@/assets/images/real-estate/customer-16.jpg'),
        require('@/assets/images/real-estate/customer-17.jpg'),
        require('@/assets/images/real-estate/customer-18.jpg'),
        require('@/assets/images/real-estate/customer-19.jpg'),
        require('@/assets/images/real-estate/customer-20.jpg'),
        require('@/assets/images/real-estate/customer-21.jpg'),
        require('@/assets/images/real-estate/customer-22.jpg'),
        require('@/assets/images/real-estate/customer-23.jpg'),
        require('@/assets/images/real-estate/customer-24.jpg'),
        require('@/assets/images/real-estate/customer-25.jpg'),
        require('@/assets/images/real-estate/customer-26.jpg'),
        require('@/assets/images/real-estate/customer-27.jpg'),
        require('@/assets/images/real-estate/customer-28.jpg'),
        require('@/assets/images/real-estate/customer-29.jpg'),
        require('@/assets/images/real-estate/customer-30.jpg'),
      ],
    }
  },
}
</script>

<style lang="less" scoped>
.customer {
  width: 100%;
  background: #fff;
  padding: 80px 0 48px;
  &-block {
    width: 1180px;
    margin: 0 auto;
  }
  .title {
    font-size: 28px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
    line-height: 40px;
    text-align: center;
  }
  .list-block {
    margin-top: 50px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .list {
      width: 180px;
      height: 62px;
      line-height: 60px;
      border: 1px solid #f3f3f3;
      margin-bottom: 32px;
      text-align: center;
      img {
        display: inline-block;
        width: 140px;
        height: 42px;
        vertical-align: middle;
      }
    }
  }
}
</style>
